import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import { loadThree } from './utils/threeLoader';

// Charger Three.js une seule fois au démarrage de l'application
// Cela évite que chaque bibliothèque charge sa propre copie
loadThree().catch((error) => {
  console.error('Failed to preload Three.js:', error);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
